module.exports = __webpack_public_path__ + "static/media/Nick2.67a9364e.JPG";